import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'Mother' },
    { value: 2, label: 'Father' },
    { value: 4, label: 'Aunt' },
    { value: 8, label: 'Brother' },
    { value: 13, label: 'Caregiver' },
    { value: 56, label: 'Family Friend' },
    { value: 18, label: 'Foster Parent' },
    { value: 6, label: 'Grandfather' },
    { value: 5, label: 'Grandmother' },
    { value: 52, label: 'Grandparent' },
    { value: 12, label: 'Guardian' },
    { value: 51, label: 'Parent' },
    { value: 57, label: 'Reunification Contact' },
    { value: 54, label: 'Sibling' },
    { value: 7, label: 'Sister' },
    { value: 11, label: 'Spouse' },
    { value: 15, label: 'Stepfather' },
    { value: 14, label: 'Stepmother' },
    { value: 53, label: 'Stepparent' },
    { value: 3, label: 'Uncle' },
    { value: 100, label: 'Other' },
  ],
});
